module.exports = __webpack_public_path__ + "static/media/instagram_icon.2d37e46c.svg";